import { Email } from './Email.js';
import { Endereco } from './Endereco.js';
import { Fisica } from './Fisica.js';
import { Juridica } from './Juridica.js';
import { Telefone } from './Telefone.js';

export class Pessoa {
  constructor(data = {}) {
    this.id = data.id ?? 0;
    this.nome = data.nome ?? '';
    this.telefoneId = data.telefoneId ?? null;
    this.emailId = data.emailId ?? null;
    this.enderecoId = data.enderecoId ?? null;
    this.fisicaId = data.fisicaId ?? null;
    this.juridicaId = data.juridicaId ?? null;

    this.telefone = Object.assign(new Telefone(), data.telefone ?? {});
    this.email = Object.assign(new Email(), data.email ?? {});

    const endereco = Object.assign(new Endereco(), data.endereco ?? {});
    endereco.cidade = Object.assign(endereco.cidade, data.endereco?.cidade ?? {});
    this.endereco = endereco;

    this.fisica = data.fisica ? Object.assign(new Fisica(), data.fisica) : null;
    this.juridica = data.juridica ? Object.assign(new Juridica(), data.juridica) : null;
  }

  normalizar() {
    this.nome = (this.nome || '').trim();
    this.endereco?.normalizar?.();
  }

  Normalizar() {
    this.normalizar();
  }
}

